// Module utilitaire d'accessibilité : annonces aux lecteurs d'écran
const a11y = (() => {
  // Annonce un message aux lecteurs d'écran via une région live temporaire
  const announce = (message) => {
    const announcer = document.createElement("div");
    announcer.setAttribute("aria-live", "polite");
    announcer.setAttribute("aria-atomic", "true");
    announcer.className = "sr-only";
    announcer.textContent = message;

    document.body.appendChild(announcer);

    // Supprimer l'élément après un court délai
    setTimeout(() => {
      document.body.removeChild(announcer);
    }, 1000);
  };

  // Crée une région live persistante pour les mises à jour (mur des annonces)
  const createLiveRegion = () => {
    if (!document.getElementById("search-status")) {
      const liveRegion = document.createElement("div");
      liveRegion.id = "search-status";
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.setAttribute("aria-atomic", "true");
      liveRegion.className = "sr-only";
      document.body.appendChild(liveRegion);
    }
  };

  return {
    announce,
    createLiveRegion
  };
})();

window.a11y = a11y;
export default a11y;
